var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"btns"},_vm._l((_vm.buttonList),function(item){return _c('span',{key:item.url,staticStyle:{"margin-right":"20px"}},[_c('router-link',{attrs:{"to":item.url}},[_vm._v(_vm._s(item.text))])],1)}),0),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }